import {$httpForm, Qs} from '../util/tools';
import qs from "qs";
import {ToastType} from "../util/toastList";
import {getUserInfo} from "../util/MyLocalStorage";

const post = "http://149.129.233.8:5058";
const baseUrl = "/politicsox";
var params = Qs();

const toQueryStr = function (obj) {
    const queryParams = [];
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            const value = obj[key];
            queryParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
        }
    }
    return queryParams.join('&');
}
const httpPost = (url, _params, loadingStr) => new Promise((resolve, reject) => {
    const showLoading = loadingStr != null && loadingStr.length !== 0;
    if (showLoading) ToastType('loading', loadingStr);
    updateParams()
    let _url = `${baseUrl}${url}?${toQueryStr(params)}`;
    $httpForm.post(_url, qs.stringify(_params))
        .then(res => {
            var currentTimestamp = Date.now(); // 获取当前时间戳（毫秒）
            if (showLoading) ToastType('hide');
            var result = responseAnalysis(res)
            if (!result.success) ToastType('Toast', result.message);
            resolve(result)
        }).catch(error => {
        ToastType('fail', error.message);
        resolve(null)
    });
});
const httpFile = (url, formData, loadingStr) => new Promise((resolve, reject) => {
    const showLoading = loadingStr != null && loadingStr.length !== 0;
    if (showLoading) ToastType('loading', loadingStr);
    updateParams()
    let _url = `${baseUrl}${url}?${toQueryStr(params)}`;
    $httpForm.post(_url, formData)
        .then(res => {
            if (showLoading) ToastType('hide');
            var result = responseAnalysis(res)
            if (!result.success) {
                ToastType('Toast', result.message);
            }
            resolve(result)
        }).catch(error => {
        ToastType('fail', error.message);
        resolve(null)
    });
});
const httpGet = (url, _params, loadingStr, isToast = true) => new Promise((resolve, reject) => {
    const showLoading = loadingStr != null && loadingStr.length !== 0;
    if (showLoading) ToastType('loading', loadingStr);
    updateParams()
    $httpForm.get(`${baseUrl}${url}?${toQueryStr(params)}&${toQueryStr(_params)}`, {})
        .then(res => {
            if (showLoading) ToastType('hide');
            var result = responseAnalysis(res)
            if (!result.success) ToastType('Toast', result.message);
            resolve(result)
        })
});

const responseAnalysis = (res) => {
    let code = res['code'.hx()]
    if (code == undefined)
        code = res['code']
    let data = res['data'.hx()] || res['data']
    let message = res['message'.hx()] || res['message']

    return {
        'success': parseInt(code) === 0,
        "code": code,
        "message": message,
        "data": data,
        "res": res
    }
}
const updateParams = () => {
    params = Qs();
    if(params['sessionId'.hx()] == undefined) {
        let userInfo = getUserInfo()
        if(userInfo!=undefined&&userInfo['sessionId'.hx()]!=undefined)
        params['sessionId'.hx()] = userInfo['sessionId'.hx()];
    }
}
export {httpPost, httpGet, httpFile, params, toQueryStr,updateParams}